<template>
    <div style="width: 100%">
        <div class="searchcontent headersearch"  >
            <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                <el-form-item>
                    <el-input size="small" v-model.trim="searchForm.keywords" placeholder="请输入公告标题" ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select size="small" v-model.trim="searchForm.is_close" placeholder="请选择公告类型" >
                        <el-option
                        v-for="item in searchForm.isCloseOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" plain type="primary" icon="el-icon-search" @click="onSearch">查询</el-button>
                </el-form-item>
            </el-form>
        </div>

        <div class="searchtable" >
            <el-table
                ref="table"
                :data="noticelist"
                border
                stripe
                v-loading="showDataLoading"
                :header-row-style="{height:'30px'}"
                :header-cell-style="{padding:'5px'}"
                :row-style="{height:'30px'}"
                :cell-style="{padding:'5px'}"
                >
                <el-table-column
                    prop="noticeID"
                    label="编号"
                    width="80">
                    <template slot-scope="scope">{{scope.$index+1}}</template>
                </el-table-column>
                <el-table-column
                    prop="noticeTitle"
                    label="公告标题"
                    min-width="250"
                    >
                </el-table-column>
                <el-table-column
                    prop="noticeType"
                    label="公告类型"
                    min-width="250">
                     <template slot-scope="scope">
                        <span v-if="scope.row.noticeType == 1">最新通知</span>
                        <span v-if="scope.row.noticeType == 2">公示公告</span>
                        <span v-if="scope.row.noticeType == 3">政策法规</span>
                        <span v-if="scope.row.noticeType == 4">文件下载</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="noticeInfo"
                    label="详情"
                    min-width="100">
                    <template slot-scope="scope">
                        <span @click="getDetail(scope.row)">
                        <el-link type="primary">详情</el-link>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    min-width="150"
                    label="发布日期">
                    
                </el-table-column>
            </el-table>

             <div class="pageblock">
                <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageIndex"
                :page-sizes="[10, 30, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount">
                </el-pagination>
            </div>

        </div>
        <!-- 详情 -->
        <el-dialog
        title="公告详情"
        :show-close="true"
        custom-class="dialog_wrap"
        :visible.sync="dialogDetailFormVisible"
        :style="'margin-top:0px;left:'+initLeft()"
        >
        <el-form
            label-width="120px"
        >
            <div v-html="noticedetail"></div>
            <div v-for="(item,k) in lsNoticeFile" :key="k" style="margin-top:30px">
                <span style="font-size:15px">附件 {{k+1}}:</span>
                <el-button  type="text" size="mini" style="font-size:15px" @click="download(item)" >{{item.fileName}} </el-button>
            </div>
        </el-form>
        <!-- <Fixationimg :valueID="noticedetail" :lsNoticeFile="lsNoticeFile"></Fixationimg> -->
        </el-dialog>
        
    </div>
</template>
<script>
import { indexnoticeModule } from "@/request/systemmange.js";
import { permissionTool } from '@/tools/permissiontool.js'
import $ from 'jquery'
import { sysframe } from '@/tools/sysframe.js'
import { publicFun } from "@/tools/time.js";
import {baseconfig,rsaBasicModuleConfig,rsaMainModuleConfig} from '@/config.js'
// import Fixationimg from "@/components/systemmange/Fixationimg.vue";
export default {
    // components:{
    //     Fixationimg
    // },
    data(){
        return {
            operKey:0,
            sourceType:1,
            noticelist: [],
            pageIndex:1,
            pageSize:10,
            totalCount:0,
            showDataLoading:true,
            addOrganizationLoading: false,
            addOrganizationisabled: false,
            dialogTitle:'',
            dialogType:0,
            dialogDetailFormVisible:false,
            noticedetail:'',
            //搜索
            searchForm: {
                keywords: '',
                 isCloseOptions: [ 
                     {
                        value: 0,
                        label: '全部'
                    },
                     {
                        value: 1,
                        label: '最新通知'
                    }, {
                        value: 2,
                        label: '公告公示'
                    }, {
                        value: 3,
                        label: '政策法规'
                    }, {
                        value: 4,
                        label: '文件下载'
                    }
                ],
                is_close:'',
            },
            //添加
            addKey:1,
            dialogAddNoticeInfoFormVisible: false,
            addRules: {
                noticeTitle: [
                    { required: true, message: '请输入公告标题', trigger: 'blur' },
                ],
               
            },
            // 上传
            uploadUrl: "",
            uploadheaders: {},
            tiem: "",
            sign: "",
            productImgList:[],
            attachmentlist:[],
            item:0,
            lsNoticeFile:[]
        }
    },
    created:async function(){
        await this.getNoticeList(this.pageIndex,this.pageSize,'',0)
        // table的高
        $('.el-table ').css('height',($(".tab-content").height()-30-$(".searchcontent").outerHeight(true)-$(".pageblock").outerHeight(true))+'px')
    },
        
    methods:{
        initLeft(){
           return sysframe.getSideBarLeft()
        },
            //时间戳
        gettimestamp(){
            return new Date().getTime();
        },
        // 获取公告列表
        async getNoticeList(page,page_size,notice_title,notice_type){
            this.noticelist=[]
            this.totalCount=0
            if(notice_type==''){
                notice_type=0
            }
            await indexnoticeModule.getNoticeList( page,page_size,notice_title,notice_type).then(response=>{
                this.showDataLoading=false
                if(response.data.lsp !==null){
                    this.lsp=response.data.lsp
                }
                switch(response.data.code){
                    case 100 :
                        this.noticelist=response.data.result
                        this.noticelist.forEach(e=>{
                            e.createTime = publicFun.timestampToTime(e.createTime)
                        })
                        this.totalCount = response.data.recordCount
                    break;
                    case 101:
                        break;
                    case 102:
                        this.$message.error(baseconfig.para_error_message);
                    break;
                    case 100002:
                        this.$message.error(baseconfig.no_permission_message);
                        break;
                    default:
                        this.$message.error(response.data.message);
                        break;
                }
            }).catch(error=>{})
        },
        // 搜索
        async onSearch() {
            console.log("rr")
            this.pageIndex=1
            this.getNoticeList(this.pageIndex,this.pageSize,this.searchForm.keywords,this.searchForm.is_close)
        },
        //更改每页显示条数
        async handleSizeChange(val) {
            this.pageSize=val
            this.pageIndex=1
            await  this.getNoticeList(this.pageIndex,this.pageSize,this.searchForm.keywords,this.searchForm.is_close);
        },
        //设置当前页
        async handleCurrentChange(val) {
            this.pageIndex=val
            await this.getNoticeList(this.pageIndex,this.pageSize,this.searchForm.keywords,this.searchForm.is_close);
        },
         // 详情
        async getDetail(row){
            await indexnoticeModule.getNoticeDetails(row.noticeID).then((res) => {
                switch (res.data.code) {
                    case 100:
                    {
                        let list = res.data.result;
                        this.noticedetail=list.noticeContent
                        this.lsNoticeFile=list.lsNoticeFile
                        this.dialogDetailFormVisible=true

                    }
                    break;
                    case 101:
                    // this.$message.error(res.data.message)
                    break;
                    case 102:
                        this.$message.error(baseconfig.para_error_message);
                    break;
                    case 103:
                    this.$message.error(res.data.message);
                    break;
                    case 100002:
                    this.$message.error(baseconfig.no_permission_message);
                    break;
                    default:
                    this.$message.error("获取信息失败");
                    break;
                }
                }).catch((error) => {});   
           
        },
        download(item){
            window.location.href=item.fileUrl
        }

    }
}
</script>
<style scoped>
    .pageblock{
        text-align: right;
        margin-top: 5px;
    }
    .tab_val{
        /* padding: 20px; */
        margin-bottom:0
    }
    .demo-ruleForm {
        display: flex;
        flex-wrap: wrap;
    }
    .demo-ruleForm .el-form-item{
        min-width: 40%;
    }
</style>